(function () {
  'use strict';

  // Format cents to EUR currency string
  function money(cents) {
    var val = (Math.round(cents) / 100).toFixed(2);
    var parts = val.split('.');
    var main = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + main + ',' + parts[1];
  }

  // 1. URGENCY RESERVATION TIMER (10 minutes, persisted in sessionStorage)
  function initTimer() {
    var timerEl = document.getElementById('spc-cart-timer');
    if (!timerEl) return;

    var STORAGE_KEY = 'spc_cart_timer_end';
    var now = Date.now();
    var endTime = sessionStorage.getItem(STORAGE_KEY);

    if (!endTime || parseInt(endTime, 10) < now) {
      endTime = now + 10 * 60 * 1000; // 10 minutes from now
      sessionStorage.setItem(STORAGE_KEY, endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }

    function update() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      var strM = m < 10 ? '0' + m : '' + m;
      var strS = s < 10 ? '0' + s : '' + s;
      timerEl.textContent = strM + ':' + strS;

      if (remaining > 0) {
        setTimeout(update, 1000);
      } else {
        timerEl.textContent = '00:00';
      }
    }
    update();
  }

  // 2. DYNAMIC FREE SHIPPING PROGRESS BAR UPDATE
  var FREE_SHIPPING_THRESHOLD = 4000; // €40.00 in cents

  function updateShippingBar(totalCents) {
    var bar = document.querySelector('[data-spc-shipping-bar]');
    if (!bar) return;

    var fill = bar.querySelector('[data-spc-bar-fill]');
    var textEl = bar.querySelector('[data-spc-bar-text]');
    var diff = FREE_SHIPPING_THRESHOLD - totalCents;

    if (diff <= 0) {
      bar.classList.add('spc-shipping-bar--unlocked');
      if (fill) fill.style.width = '100%';
      if (textEl) {
        textEl.innerHTML = '<span class="spc-shipping-bar__icon">🎉</span><span><strong>Congratulations!</strong> You have unlocked <strong>FREE Tracked Delivery!</strong></span>';
      }
    } else {
      bar.classList.remove('spc-shipping-bar--unlocked');
      var pct = Math.min(100, Math.max(5, Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100)));
      if (fill) fill.style.width = pct + '%';
      if (textEl) {
        textEl.innerHTML = '<span class="spc-shipping-bar__icon">🚚</span><span>Add <strong>' + money(diff) + '</strong> more to unlock <strong>FREE Tracked Delivery!</strong></span>';
      }
    }
  }

  // 3. AJAX QUANTITY STEPPER & REMOVE
  function initQuantityControls() {
    var root = document.querySelector('[data-spc-cart]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-spc-qty-action]');
      var removeBtn = e.target.closest('[data-spc-remove]');

      if (btn) {
        var action = btn.dataset.spcQtyAction;
        var line = parseInt(btn.dataset.line, 10);
        var currentQty = parseInt(btn.dataset.currentQty, 10);
        var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;

        if (newQty >= 0) {
          updateLine(line, newQty);
        }
      }

      if (removeBtn) {
        e.preventDefault();
        var rLine = parseInt(removeBtn.dataset.line, 10);
        updateLine(rLine, 0);
      }
    });

    // Handle 1-click in-cart upsell add
    root.addEventListener('click', function (e) {
      var upsellBtn = e.target.closest('[data-spc-upsell-add]');
      if (!upsellBtn) return;

      var variantId = upsellBtn.dataset.variantId;
      if (!variantId) return;

      upsellBtn.disabled = true;
      upsellBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        window.location.reload();
      })
      .catch(function () {
        upsellBtn.textContent = '+ ADD';
        upsellBtn.disabled = false;
      });
    });

    // Auto-save cart notes on blur
    var noteEl = root.querySelector('[data-spc-cart-note]');
    if (noteEl) {
      noteEl.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        }).catch(function () {});
      });
    }
  }

  function updateLine(line, qty) {
    var root = document.querySelector('[data-spc-cart]');
    if (root) root.style.opacity = '0.6';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Change failed');
      return res.json();
    })
    .then(function (cart) {
      // Reload page smoothly to re-render all lines and bundle tiers accurately
      window.location.reload();
    })
    .catch(function (err) {
      console.error(err);
      window.location.reload();
    });
  }

  // Initialize on load or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTimer();
      initQuantityControls();
    });
  } else {
    initTimer();
    initQuantityControls();
  }

})();
